module.exports = __webpack_public_path__ + "11af01184c4541c61ccbc5a3326d32ed.svg";